import { supabase } from './supabase'

/**
 * Find existing client by name and date of birth
 * Returns client with medical history if found
 */
export const findExistingClient = async (organizationId, firstName, lastName, dateOfBirth) => {
  try {
    if (!organizationId || !firstName || !lastName || !dateOfBirth) {
      return null
    }

    // Normalize names for comparison (case-insensitive, trimmed)
    const normalizedFirstName = firstName.trim().toLowerCase()
    const normalizedLastName = lastName.trim().toLowerCase()

    // Query for matching client
    const { data: clients, error } = await supabase
      .from('clients')
      .select('*, medical_histories(*)')
      .eq('organization_id', organizationId)
      .eq('date_of_birth', dateOfBirth)
      .ilike('first_name', normalizedFirstName)
      .ilike('last_name', normalizedLastName)
      .order('created_at', { ascending: false })
      .limit(1)

    if (error) {
      console.error('Error finding existing client:', error)
      return null
    }

    if (clients && clients.length > 0) {
      const client = clients[0]
      // Get latest medical history if not included
      if (!client.medical_histories || client.medical_histories.length === 0) {
        const { data: history } = await supabase
          .from('medical_histories')
          .select('*')
          .eq('client_id', client.id)
          .eq('organization_id', organizationId)
          .order('created_at', { ascending: false })
          .limit(1)
          .single()

        return {
          ...client,
          medical_history: history,
        }
      }

      return {
        ...client,
        medical_history: Array.isArray(client.medical_histories) 
          ? client.medical_histories[0] 
          : client.medical_histories,
      }
    }

    return null
  } catch (error) {
    console.error('Error in findExistingClient:', error)
    return null
  }
}

